// fetchResolutions.js
// Loads /tickets/resolutions data from public.v_resolutions.
//
// v_resolutions joins type='resolution' tickets (created by subagents via
// open_resolution_ticket()) with their original ticket's resolution JSONB, so
// the UI gets fix context + original link in one query.
//
// Shape returned (one entry per resolution ticket):
//   {
//     resolutionTicketId,   // resolution ticket id
//     resolutionExternalId, // resolution ticket external_id (if any)
//     resolutionTitle,      // "Resolution: <original title>"
//     resolvedAt,           // ISO timestamp
//     resolvedBy,           // agent email that shipped the fix
//     workspaceId,
//     originalTicketId,     // parent original ticket id — links to /tickets/canvas?ticket=<id>
//     originalExternalId,
//     originalTitle,
//     originalType,
//     summary,              // resolution.summary
//     rootCause,            // resolution.root_cause
//     fix,                  // resolution.fix
//     filesTouched,         // resolution.files_touched (array or null)
//     commitSha,            // resolution.commit_sha
//     prevention            // resolution.prevention
//   }

import { SUPABASE_URL, restHeaders } from '../../../shared/functions/supabaseConfig.js'

const WORKSPACE_ID = '69e5911201b0ef47b675463f'

export const fetchResolutions = async ({ limit = 100 } = {}) => {
  const url = `${SUPABASE_URL}/rest/v1/v_resolutions?workspace_id=eq.${WORKSPACE_ID}&order=resolved_at.desc&limit=${limit}`
  let rows
  try {
    const res = await fetch(url, { headers: restHeaders() })
    if (!res.ok) {
      console.warn('[fetchResolutions] v_resolutions fetch failed', res.status)
      return []
    }
    rows = await res.json()
  } catch (err) {
    console.warn('[fetchResolutions] network error', err)
    return []
  }
  if (!Array.isArray(rows)) return []

  return rows.map((r) => ({
    resolutionTicketId:   r.resolution_ticket_id,
    resolutionExternalId: r.resolution_external_id || null,
    resolutionTitle:      r.resolution_title || '',
    resolvedAt:           r.resolved_at || null,
    resolvedBy:           r.resolved_by || null,
    workspaceId:          r.workspace_id || WORKSPACE_ID,
    originalTicketId:     r.original_ticket_id || null,
    originalExternalId:   r.original_external_id || null,
    originalTitle:        r.original_title || null,
    originalType:         r.original_type || null,
    summary:              r.summary || null,
    rootCause:            r.root_cause || null,
    fix:                  r.fix || null,
    filesTouched:         r.files_touched
      ? (Array.isArray(r.files_touched) ? r.files_touched : Object.values(r.files_touched))
      : [],
    commitSha:   r.commit_sha || null,
    prevention:  r.prevention || null
  }))
}
